import React from 'react';
import css from './DuplicateModal.less';
import Row from '@/src/components/Layouts/Row/Row';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Input from '@/src/components/Antd/Input/Input';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import { Radio } from '@/src/components/Antd';
import { EnumStatus } from 'src/types/common/product';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const DuplicateModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setModal, onSubmit, radioList = [] } = props;

  const [productStatus, setProductStatus] = React.useState(EnumStatus.Draft);
  const [title, setTitle] = React.useState('');
  const [titleErr, setTitleErr] = React.useState(false);
  const onTitleChange = (e) => {
    setTitle(e);
    if (titleErr) setTitleErr(false);
  };
  const handleRadioChange = (e) => {
    setProductStatus(e.target.value);
  };
  const onCancel = () => {
    if (setModal) setModal(false);
  };

  const onOk = () => {
    if (!title) {
      setTitleErr(true);
      return;
    }

    if (onSubmit) onSubmit({ productStatus, title });
    if (setModal) setModal(false);
  };
  return (
    <React.Fragment>
      <Row
        elements={[
          {
            child: (
              <React.Fragment>
                <TopContainer>
                  <ItemWrapper
                    title={getI18n(
                      'allProducts.addproductset.customInformation_component_title',
                    )}>
                    <Input
                      error={titleErr}
                      autoFocus
                      size='large'
                      value={title}
                      onChange={onTitleChange}
                    />
                  </ItemWrapper>
                </TopContainer>
              </React.Fragment>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <React.Fragment>
                <TopContainer>
                  <ItemWrapper
                    title={getI18n(
                      'allProducts.productEditor.components_DuplicateModal',
                    )}>
                    <Radio
                      className={css.radio}
                      onChange={handleRadioChange}
                      radioList={radioList}
                      value={productStatus}
                    />
                  </ItemWrapper>
                </TopContainer>
                <ModalFooter onCancel={onCancel} onOk={onOk} />
              </React.Fragment>
            ),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default DuplicateModal;
